import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Edit from '@mui/icons-material/Edit';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import './styles.css';

const ITEM_HEIGHT = 48;

export default function ListManagementDropdown(props) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
    const handleClose = () => {
        setAnchorEl(null);
    };

    function handleRemoveItem() {
      handleClose();
      props.toggleRemoveItemButton();
    }

    function handleDeleteList() {
      handleClose();
      props.handleRemoveList();
    }

    function handleRename() {
      handleClose();
      props.toggleRenameMenu();
    }


    return (
        
        <>
        <IconButton
          aria-label="more"
          id="long-button"
          aria-controls={open ? 'long-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          MenuListProps={{
            'aria-labelledby': 'long-button',
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: '20ch',
            },
          }}
        >

        <MenuItem onClick={handleRemoveItem}>
            <RemoveCircleOutlineIcon />
            &nbsp;&nbsp;Remove Items
        </MenuItem>
        <MenuItem onClick={handleRename}>
            <Edit />
            &nbsp;&nbsp;Rename List
        </MenuItem>        
        <MenuItem onClick={handleDeleteList}>
            <DeleteIcon />
            &nbsp;&nbsp;Delete List
        </MenuItem>

        </Menu>
      </>
      );
}